import React, {useEffect} from 'react'
import { Link, useLocation } from "react-router-dom";
import posts from '../../Constants/posts';
import PageNotFound from '../../Layouts/PageNotFound';
import Banner from '../Banner';
import { backgroundColorCounter } from '../Home/style';
import ReviewBox from '../ReviewBox';
import Sticky from 'sticky-js';
import { Review, reviewItem } from '../ReviewBox';
import { Swiper, SwiperSlide } from "swiper/react";
import{ init, send } from 'emailjs-com';
import emailkey from '../../emailkey';
import $ from 'jquery';

// Import Swiper styles
import "swiper/swiper.min.css";

// import Swiper core and required modules
import SwiperCore, {
  Pagination, Navigation
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Pagination, Navigation]);
interface ItemPost {
    id: number
    title: string
    description: string
    content: string
    author: string
    authorImage : string
    releaseDate: string
    image: string
}

function itemPost(item: ItemPost,animation=true,swiper=false, onClick = function click() {}) {
    return(
        <SwiperSlide key={item.id} className={swiper?"":"col-lg-4"}>
            {/* <!-- blog card --> */}
            <div className={animation?"knsl-blog-card knsl-scroll-animation":"knsl-blog-card"}>
              <div className="knsl-cover-frame">
                <Link onClick={onClick} to={`/post?id=${item.id}`}><img src={item.image} alt={`${item.image} - The West Haven Hotel`} /></Link>
              </div>
              <div className="knsl-description-frame">
                <div className="knsl-room-features">
                  <div className="knsl-feature">
                    <div className="knsl-icon-frame knsl-icon-author"><img src={item.authorImage} alt={item.author} /></div>
                    <span>{item.author}</span>
                  </div>
                  <div className="knsl-feature">
                    <div className="knsl-icon-frame"><img src="assets/img/icons/time.svg" alt="Date" /></div>
                    <span>{item.releaseDate}</span>
                  </div>
                </div>
                <Link onClick={onClick} to={`/post?id=${item.id}`}>
                  <h4 className="knsl-mb-20">{item.title}</h4>
                </Link>
                <div className="knsl-text-light knsl-text-sm">{item.description}</div>
              </div>
            </div>
            {/* <!-- blog card end --> */}
        </SwiperSlide>
    )
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Post() {

    let query = useQuery();
    let id = parseInt(''+query.get('id'));
    let post =  posts.find(post => post.id===id)

    const banner = {
        title : post?post.title:'',
        description : '',
        navigation : [{path: '/blog', title: 'Blog'}, {path: `/post?id=${id}`, title: post?post.title.slice(0,30)+'...':''}]
    }

    const reviews =  [
        {author: {name : 'Sofia Oldman', profile : 'assets/img/faces/3.jpg'}, date: '14.07.2021', mark : 5, review: 'Dequi folores dolor sit amet, consectetur adipisicing elit. Nesciunt illo, delectus totam! Delectus illo magnam voluptatem a tempora id vitae dolor, quis natus iusto molestiae ab nam error vero possimus ullam facilis porro veritatis.'},
        {author: {name : 'Emma Newman', profile : 'assets/img/faces/2.jpg'}, date: '14.07.2021', mark : 4, review: 'Dequi folores dolor sit amet, consectetur adipisicing elit. Nesciunt illo, delectus totam! Delectus illo magnam voluptatem a tempora id vitae dolor, quis natus iusto molestiae ab nam error vero possimus ullam facilis porro veritatis.'},
    ]

    function submitReview (name: string, email: string, text : string) {
        let comment = {name, email, text}
        init(emailkey.USER_ID);
        send(emailkey.SERVICE_ID, emailkey.TEMPLATE_ID, comment, emailkey.USER_ID)
        .then((result: any) => {
            console.log("Message Sent, We will get back to you shortly", result.text);
        },
        (error: any) => {
            console.log("An error occurred, Please try again", error.text);
        });
    }

    function blogSidebar (post : ItemPost) {
        return(
            <div className="knsl-blog-card knsl-blog-card-sm">
                <div className="knsl-cover-frame">
                <Link to={`/post?id=${post.id}`} onClick={goToTop}><img src={post.image} alt={post.title}/></Link>
                </div>
                <div className="knsl-description-frame">
                <Link to={`/post?id=${post.id}`} onClick={goToTop}>
                    <h5 className="knsl-mb-10">{post.title}</h5>
                </Link>
                <div className="knsl-text-light knsl-text-sm">{post.description.slice(0,50)+'...'}</div>
                </div>
            </div>
        )
    }

    const goToTop = () => window.scrollTo(0, 0);

    
    useEffect(() => {
        goToTop();
        let sticky = new Sticky('.knsl-sticky');
        if ($(window).width() < 992) {
            sticky.destroy();
        }
    }, []);

    if(post)
        return (
            <>
                <Banner data={banner} />

                <div className="knsl-p-100-100">
                    <div className="container">
                        <div className="row" data-sticky-container>

                        <div className="col-lg-8">

                            <img src={post.image} alt={post.title} className="knsl-default-img knsl-mb-30" />

                            <div className="knsl-blog-post knsl-mb-60" dangerouslySetInnerHTML={{__html: post.content}}></div>
                            
                            {/* <!-- comments --> */}
                            <section className="knsl-mb-30">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <h3 className="knsl-mb-40 knsl-scroll-animation">Comments</h3>
                                    </div>

                                    {reviews.map((review:Review,index) => reviewItem(review,index))}
                                </div>
                            </section>
                            {/* <!-- comments end --> */}

                            <ReviewBox onSubmit={submitReview} end="comment" />

                        </div>
                        <div className="col-lg-4">
                            {/* <!-- sidebar --> */}
                            <div className="knsl-sticky knsl-stycky-right" data-margin-top="100">

                                <div className="knsl-room-features-lg knsl-mb-30 justify-content-start">
                                    <div className="knsl-feature">
                                    <div className="knsl-icon-frame knsl-icon-author"><img src={post.authorImage} alt={post.author}/></div>
                                    <span>{post.author}</span>
                                    </div>
                                    <div className="knsl-feature">
                                    <div className="knsl-icon-frame"><img src="assets/img/icons/time.svg" alt="icon"/></div>
                                    <span>{post.releaseDate}</span>
                                    </div>
                                </div>

                                <h4 className="knsl-mb-30">Similar publications</h4>

                                {posts.slice(id+1,id+5).map(post => blogSidebar(post))}

                            </div>
                            {/* <!-- sidebar end --> */}
                        </div>

                        </div>
                    </div>
                </div>

                <section className="knsl-transition-top knsl-p-0-100" style={backgroundColorCounter}>
                    <img src="img/palm.svg" className="knsl-deco-left" alt="palm" />
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12">

                                <div className="knsl-center knsl-title-frame knsl-scroll-animation knsl-mb-100">
                                <h2 className="knsl-mb-20">Popular Publications</h2>
                                <p className="knsl-mb-30">Consectetur adipisicing elit. Nihil, illum voluptate eveniet ex fugit ea delectus, sed voluptatem. Laborum accusantium libero commodi id officiis itaque esse adipisci, necessitatibus asperiores, illo odio.</p>
                                <Link to="/blog" className="knsl-btn knsl-btn-md">All publications</Link>
                                </div>

                            </div>
                            <div className="col-lg-12">
                                

                            </div>
                        </div>
                    </div>
                    <div className="swiper-container knsl-uni-slider">
                            <Swiper 
                                slidesPerView={1} 
                                spaceBetween={20} 
                                parallax={true} 
                                updateOnWindowResize={true} initialSlide={1} 
                                speed={800} 
                                breakpoints={{1600 : {slidesPerView: 5}, 1200 : {slidesPerView: 4}, 760 : {slidesPerView: 3}} } 
                                centeredSlides={true}
                                pagination={{el: '.knsl-uni-slider-pagination',type: "fraction",}}
                                navigation={{prevEl: '.knsl-uni-slider-prev',nextEl: '.knsl-uni-slider-next'}}
                            >
                                {posts.slice(0,6).map((item) => itemPost(item, true, true, goToTop))}

                                {/* <!-- slider navigation --> */}
                                <div className="container">
                                <div className="knsl-uni-slider-nav-panel">
                                    {/* <!-- pagination --> */}
                                    <div className="knsl-uni-slider-pagination" style={{marginLeft: '30px'}}></div>
                                    {/* <!-- navigation --> */}
                                    <div className="knsl-uni-nav" style={{marginRight: '30px'}}>
                                    <div className="knsl-uni-slider-prev"><i className="fas fa-arrow-left" ></i></div>
                                    <div className="knsl-uni-slider-next"><i className="fas fa-arrow-right"></i></div>
                                    </div>
                                    {/* <!-- navigation end --> */}
                                </div>
                                </div>
                                {/* <!-- slider navigation end --> */}
                            </Swiper>
                        </div>
                </section>
            </>
        );
    else
        return <PageNotFound />
}

export default Post

export {itemPost}

export type {ItemPost}